import React from 'react';
import PropTypes from 'prop-types';
import Button from 'reactstrap/lib/Button';
import { getStaticImageUrl } from 'client/utils/image-helpers';

export function ErrorState({ onRetry = null }) {
  const FORM_ERROR_IMAGE = '/img/lead-form/tow_truck.png';
  return (
    <div className="mt-3_5 mb-1 text-center">
      <img className="mb-3 w-100" src={getStaticImageUrl(FORM_ERROR_IMAGE)} alt="Form error" />
      <p className="display-2 mb-0_25 mb-md-0_5 mx-2_5">Sorry, something didn&apos;t go as expected.</p>
      <p className="display-3 mb-1_5 mb-md-2">Please check back later</p>
      {onRetry && (
        <Button className="try-again-btn" color="success" onClick={onRetry}>
          Try Again
        </Button>
      )}
    </div>
  );
}

ErrorState.propTypes = {
  onRetry: PropTypes.func,
};
